import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchSimoDeviceDiagnostic } from 'actions/simoDiagnostic';
import { getSimoDeviceDiagnostics } from 'reducers';

const withSimoDiagnosticData = (DecoratedComponent) => {
  class WithSimoDiagnosticData extends Component {
    state = {
      diagnosticDataLoadingStatus: '',
    };

    componentDidMount() {
      this.fetchSubDiagnostic();
    }

    componentDidUpdate(prevProps, prevState) {
      if (!prevProps.sub && this.props.sub) {
        this.fetchSubDiagnostic();
      }
    }

    fetchSubDiagnostic = () => {
      const { fetchSimoDeviceDiagnostic, sub } = this.props;
      if (sub && sub.simo_status === 'active' && sub.device) {
        this.setState({ diagnosticDataLoadingStatus: 'Loading...' });
        fetchSimoDeviceDiagnostic(sub.device)
          .then((res) => {
            if (res && res.error) {
              this.setState({
                diagnosticDataLoadingStatus: 'Failed to load diagnostic data',
              });
              return;
            }
            this.setState({ diagnosticDataLoadingStatus: '' });
          })
          .catch((e) => {
            this.setState({
              diagnosticDataLoadingStatus: 'Failed to load diagnostic data',
            });
          });
      }
    };

    render() {
      const { children, ...props } = this.props;
      const { diagnosticDataLoadingStatus } = this.state;
      const childProps = {
        diagnosticDataLoadingStatus,
        ...props,
      };
      return React.createElement(DecoratedComponent, childProps, children);
    }
  }

  const mapStateToProps = (state, { sub }) => {
    const diagnosticData = getSimoDeviceDiagnostics(state, sub?.device);
    return {
      diagnosticData,
    };
  };

  const mapDispatchToProps = {
    fetchSimoDeviceDiagnostic,
  };

  return connect(mapStateToProps, mapDispatchToProps)(WithSimoDiagnosticData);
};

export default withSimoDiagnosticData;
